
















































































































import mixins from 'vue-typed-mixins';
import VModelMixin from '@/mixins/VModelMixin';
import SettingsMixin from '@/mixins/SettingsMixin';
import UserMixin from '@/mixins/UserMixin';
import OrderConfirmationMixin from '@/mixins/OrderConfirmationMixin';
// @ts-ignore
import { VueEditor } from 'vue2-editor';
import IEmployeeFunction from '@/models/IEmployeeFunction';
import Language from '@/models/Language';
import { PropType } from 'vue';
import QuillOptions from '@/models/QuillOptions';
import TagSelection from '@/components/TagSelectionComponent/TagSelection.vue';

export type MailSelectionItem = {
  id: number;
  name: string;
  slug: string;
};
export type FormData = {
  toReceiverMailAddresses: Array<MailSelectionItem>;
  ccReceiverMailAddresses: Array<MailSelectionItem>;
  senderMailAddress: string;
  selectedEmployeeFunction: IEmployeeFunction | null;
  mailSubject: string;
  mailContent: string;
  isGeneratingMailContent: boolean;
};
export default mixins(VModelMixin, SettingsMixin, UserMixin, OrderConfirmationMixin).extend({
  components: {
    VueEditor,
    TagSelection
  },
  props: {
    language: Number,
    availableToReceiverMailAddresses: Array as PropType<Array<MailSelectionItem>>,
    availableCcReceiverMailAddresses: Array as PropType<Array<MailSelectionItem>>,
    availableEmployeeFunctions: Array as PropType<IEmployeeFunction[]>,

    formData: Object as PropType<FormData>
  },
  data() {
    return {
      quillOptions: QuillOptions.config
    };
  },
  methods: {
    getJobTitle(employeeFunction: IEmployeeFunction) {
      switch (this.language) {
        case Language.EN:
          return employeeFunction.nameEn;
        case Language.FR:
          return employeeFunction.nameFr;
        case Language.IT:
          return employeeFunction.nameIt;
        case Language.DE:
        default:
          return employeeFunction.nameDe;
      }
    },
    toReceiverMailAddressAdded: async function (receiverToAdd: MailSelectionItem) {
      const alreadyInList = this.formData.toReceiverMailAddresses.some(
        (receiver) => receiver.name.toLowerCase() == receiverToAdd.name.toLowerCase()
      );
      if (!alreadyInList) {
        this.formData.toReceiverMailAddresses.push(receiverToAdd);
      }
    },
    toReceiverMailAddressRemoved: async function (receiverToRemove: MailSelectionItem) {
      this.formData.toReceiverMailAddresses = this.formData.toReceiverMailAddresses.filter(
        (receiver) => receiver.name.toLowerCase() != receiverToRemove.name.toLowerCase()
      );
    },
    ccReceiverMailAddressAdded: async function (receiverToAdd: MailSelectionItem) {
      const alreadyInList = this.formData.ccReceiverMailAddresses.some(
        (receiver) => receiver.name.toLowerCase() == receiverToAdd.name.toLowerCase()
      );
      if (!alreadyInList) {
        this.formData.ccReceiverMailAddresses.push(receiverToAdd);
      }
    },
    ccReceiverMailAddressRemoved: async function (receiverToRemove: MailSelectionItem) {
      this.formData.ccReceiverMailAddresses = this.formData.ccReceiverMailAddresses.filter(
        (receiver) => receiver.name.toLowerCase() != receiverToRemove.name.toLowerCase()
      );
    },
    emitSelectedJobTitleChanged() {
      this.$emit('selected-job-title-changed');
    },
    emitResetMailReceivers() {
      this.$emit('reset-mail-receivers');
    }
  }
});
